import { dataHooks } from '@wix/data-hooks'

export const welcomeDataHooks = dataHooks<{
  title: {}
  subtitle: {}
  disclaimer: {}
  skip: {}
  next: {}
  radio: { optionKey: string }
}>('welcome')
